import React, { forwardRef } from "react";

import { cva, VariantProps } from "class-variance-authority";

const styles = cva(
  [
    "absolute z-10 mt-2 ",
    "text-gray-700",
    "rounded-md bg-white shadow-lg outline outline-gray-200 focus:outline-none",
  ],
  {
    variants: {
      alignVariant: {
        left: [],
        right: ["right-0", "origin-top-right"],
      },
      dividersVariant: {
        true: ["divide-y divide-gray-100"],
        false: [],
      },
    },
    defaultVariants: {
      dividersVariant: false,
    },
  },
);

type VProps = VariantProps<typeof styles>;

export interface MenuItemsProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VProps {}

/**
 *
 */
export const MenuItems = forwardRef<HTMLDivElement, MenuItemsProps>(
  ({ className, alignVariant, dividersVariant, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={styles({ className, alignVariant, dividersVariant })}
        {...props}
      >
        {children}
      </div>
    );
  },
);
export default MenuItems;
